import { createContext } from 'react';
import { guideInitialState } from './store/reducer';

const GuideContext = createContext(guideInitialState);

export default GuideContext;
